<template>
    <main>
      <section class="py-10 bg-gray-100">
        <div class="md:px-4 max-w-screen-3xl mx-auto py-10">
          <div class="flex justify-center flex-wrap gap-8">
            <!-- Card 1 -->
            <div class="bg-white cursor-pointer shadow-lg rounded-full w-56 h-56 flex flex-col items-center justify-center transition-transform duration-300 hover:scale-105 hover:shadow-xl">
              <div
                class="w-10 h-10 bg-blue rounded-full flex justify-center items-center"
                @mouseenter="toggleIconState('phone')"
                @mouseleave="toggleIconState('phone')"
              >
                <i class="fa-solid fa-phone text-2xl text-white"></i>
              </div>
              <p class="text-center mt-4 text-gray-700 font-medium">
                <a href="tel:+2347068777793" class="text-blue-500 hover:underline">
                  +234 706 877 7793
                </a>
              </p>
            </div>
  
            <!-- Card 2 -->
            <div class="bg-white cursor-pointer shadow-lg rounded-full w-56 h-56 flex flex-col items-center justify-center transition-transform duration-300 hover:scale-105 hover:shadow-xl">
              <div
                class="w-10 h-10 bg-blue rounded-full flex justify-center items-center"
                @mouseenter="toggleIconState('email')"
                @mouseleave="toggleIconState('email')"
              >
                <i class="fa-solid fa-envelope text-2xl text-white"></i>
              </div>
              <p class="text-center mt-4 text-gray-700 font-medium">
                <a href="mailto:info@barkamshelia.com" class="text-blue-500 hover:underline">
                  info&#64;barkamshelia.com
                </a>
              </p>
            </div>
  
            <!-- Card 3 -->
            <div class="bg-white cursor-pointer shadow-lg rounded-full w-56 h-56 flex flex-col items-center justify-center transition-transform duration-300 hover:scale-105 hover:shadow-xl">
              <div
                class="w-10 h-10 bg-blue rounded-full flex justify-center items-center"
                @mouseenter="toggleIconState('location')"
                @mouseleave="toggleIconState('location')"
              >
                <i class="fa-solid fa-earth-oceania text-2xl text-white"></i>
              </div>
              <p class="text-center mt-4 text-gray-700 font-medium px-4">
                The Mshel Hub, No. 2 Julius Adelusi Street, Guzape, Abuja.
              </p>
            </div>
  
            <!-- Card 4 -->
            <div class="bg-white cursor-pointer shadow-lg rounded-full w-56 h-56 flex flex-col items-center justify-center transition-transform duration-300 hover:scale-105 hover:shadow-xl">
              <div
                class="w-10 h-10 bg-blue rounded-full flex justify-center items-center"
                @mouseenter="toggleIconState('hours')"
                @mouseleave="toggleIconState('hours')"
              >
                <i class="fa-solid fa-hourglass-start text-2xl text-white"></i>
              </div>
              <p class="text-center mt-4 text-gray-700 font-medium">
                Open hours: 8.00-17.00 Mon-Fri
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  </template>
  
  <script>
  export default {
    methods: {
      toggleIconState(icon) {
        // Add your hover interactivity here if needed
      },
    },
  };
  </script>
  
  <style scoped>
  .bg-gray-100 {
    background-color: #f9f9f9;
  }
  
  .hover\:scale-105:hover {
    transform: scale(1.05);
  }
  
  .hover\:shadow-xl:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  }
  </style>
  